export interface ManagementLoginResult {
  expiresInSeconds?: number;
}

export function sessionExpiresAt(_result: ManagementLoginResult, _now = Date.now()): number | undefined {
  const seconds = Number(_result.expiresInSeconds);
  if (!Number.isFinite(seconds) || seconds <= 0) return undefined;
  return _now + Math.floor(seconds * 1000);
}

export function getSessionExpiry(_token: string): number | undefined {
  try {
    const payload = _token.split(".")[0];
    if (!payload) return undefined;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(payload.length / 4) * 4, "=");
    const parsed = JSON.parse(atob(normalized)) as { exp?: unknown };
    const expiresAt = Number(parsed.exp);
    return Number.isFinite(expiresAt) && expiresAt > 0 ? expiresAt : undefined;
  } catch {
    return undefined;
  }
}

export function isSessionExpired(_expiresAt: number | undefined, _now = Date.now()): boolean {
  return _expiresAt !== undefined && _expiresAt <= _now;
}
